import styled from 'styled-components';

/** Стили, общие для частей экрана позиций объёма. Локальные — в своих файлах. */

export const Muted = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 14px;
`;

export const Badge = styled.span<{ $tone: 'ok' | 'warn' | 'muted' }>`
  display: inline-block;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: ${({ theme }) => theme.radius.pill};
  color: ${({ $tone, theme }) =>
    $tone === 'ok'
      ? theme.colors.primary
      : $tone === 'warn'
        ? 'crimson'
        : theme.colors.text.secondary};
  border: 1px solid
    ${({ $tone, theme }) =>
      $tone === 'ok' ? theme.colors.primary : $tone === 'warn' ? 'crimson' : theme.colors.border};
`;
